module.exports = __webpack_public_path__ + "img/modal-go-to-app@3x.15ab61d8.png";